var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoloFriendly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_787_5074)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3959 40.2145H43.396C44.8289 40.2145 46.0013 39.0421 46.0013 37.6092V35.8546C46.0013 34.4217 44.8289 33.2493 43.396 33.2493H43.3959C41.9629 33.2493 40.7906 34.4217 40.7906 35.8546V37.6092C40.7907 39.0421 41.963 40.2145 43.3959 40.2145ZM4.60531 39.3438C6.03828 39.3438 7.21072 38.1715 7.21072 36.7385V34.984C7.21072 33.551 6.03838 32.3787 4.60541 32.3787C3.17244 32.3787 2 33.551 2 34.984V36.7385C1.99991 38.1715 3.17234 39.3438 4.60531 39.3438Z",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7361 30.54C18.3333 30.54 21.2494 27.6165 21.2494 24.0101C21.2494 20.4037 18.3333 17.4802 14.7361 17.4802C11.1388 17.4802 8.22266 20.4037 8.22266 24.0101C8.22266 27.6165 11.1388 30.54 14.7361 30.54Z",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8433 46.434V41.0504C22.8433 35.3041 27.5328 30.6026 33.2646 30.6026C36.375 30.6026 39.178 31.9874 41.0917 34.172M43.6684 40.4529C43.6798 40.6508 43.6861 40.8498 43.6861 41.0504V47.0626H4.31641V41.0504C4.31641 40.5547 4.35213 40.067 4.41953 39.5891M7.21947 33.834C9.1195 31.8454 11.7908 30.6025 14.7378 30.6025H33.2646",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2634 30.54C36.8606 30.54 39.7767 27.6165 39.7767 24.0101C39.7767 20.4037 36.8606 17.4802 33.2634 17.4802C29.6661 17.4802 26.75 20.4037 26.75 24.0101C26.75 27.6165 29.6661 30.54 33.2634 30.54Z",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1055 41.9558V46.4339M37.8958 41.9558V46.4339",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0001 0L26.2882 4.25344L31.0405 5.11519L27.7024 8.60578L28.3513 13.3917L24.0001 11.2957L19.6489 13.3917L20.2978 8.60578L16.9596 5.11519L21.7119 4.25344L24.0001 0ZM39.4419 4.58175L41.0764 7.61991L44.4709 8.23547L42.0864 10.7287L42.55 14.1473L39.4419 12.65L36.3339 14.1473L36.7975 10.7287L34.4131 8.23547L37.8076 7.61991L39.4419 4.58175ZM8.55824 4.58175L6.9238 7.61991L3.5293 8.23547L5.91373 10.7287L5.45014 14.1473L8.55824 12.65L11.6662 14.1473L11.2027 10.7287L13.5871 8.23547L10.1926 7.61991L8.55824 4.58175Z",
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_787_5074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoloFriendly);
export default __webpack_public_path__ + "static/media/solo-friendly.9ae07e7af4b2314548150f5e3b5dff34.svg";
export { ForwardRef as ReactComponent };